// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3nUUE","body":"style_body__6C3q9"};